import React from 'react';
import { Anchor, Mail, Phone } from 'lucide-react';

const Footer = ({ companyInfo }) => {
  if (!companyInfo) return null;
  return (
    <footer className="dark-container py-16 border-t border-border-subtle">
      <div className="dark-content-container">
        <div className="grid lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_sea-forward/artifacts/vucx67ga_ChatGPT%20Image%20Oct%2011%2C%202025%2C%2011_49_30%20AM.png" 
                alt="AquaSage Advisory Logo" 
                className="w-10 h-10 object-contain"
              />
              <span className="font-semibold text-xl" style={{color: 'var(--text-primary)'}}>{companyInfo.name}</span>
            </div>
            
            <p className="body-medium text-text-secondary mb-6 max-w-md">
              Pioneer next-generation maritime asset transformation, driving sustainability and operational excellence for long-term value. Digitizing ships, cargo, and crew operations through AI and innovation.
            </p>
            
            <div className="space-y-3">
              <div className="flex items-center gap-3">
                <Mail className="text-brand-primary" size={18} />
                <span className="body-small text-text-muted">{companyInfo.contact.email}</span>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="text-brand-primary" size={18} />
                <span className="body-small text-text-muted">{companyInfo.contact.phone}</span>
              </div>
            </div>
          </div>
          
          {/* Services */}
          <div>
            <h4 className="heading-3 text-white mb-6">Services</h4>
            <ul className="space-y-3">
              <li><a href="#services" className="body-small text-text-muted hover:text-brand-primary transition-colors">Vessel Management</a></li>
              <li><a href="#services" className="body-small text-text-muted hover:text-brand-primary transition-colors">Acquisition Advisory</a></li>
              <li><a href="#services" className="body-small text-text-muted hover:text-brand-primary transition-colors">Sustainable Shipping</a></li>
              <li><a href="#services" className="body-small text-text-muted hover:text-brand-primary transition-colors">Maritime Tech</a></li>
              <li><a href="#services" className="body-small text-text-muted hover:text-brand-primary transition-colors">Leadership Coaching</a></li>
            </ul>
          </div>
          
          {/* Company */}
          <div>
            <h4 className="heading-3 text-white mb-6">Company</h4>
            <ul className="space-y-3">
              <li><a href="#about" className="body-small text-text-muted hover:text-brand-primary transition-colors">About Us</a></li>
              <li><a href="#contact" className="body-small text-text-muted hover:text-brand-primary transition-colors">Contact</a></li>
              <li><a href="#" className="body-small text-text-muted hover:text-brand-primary transition-colors">Careers</a></li>
              <li><a href="#" className="body-small text-text-muted hover:text-brand-primary transition-colors">Privacy Policy</a></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-border-subtle mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <div className="body-small text-text-muted">
            © 2024 {companyInfo.name}. All rights reserved.
          </div>
          <div className="body-small text-text-muted mt-4 md:mt-0">
            {companyInfo.contact.founder} - {companyInfo.contact.title}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;